import { useAdminSelector } from "../../../stores/AdminStore";

export const useAdminApiRequestStatus = () => {
  const excludedQueries = [
    "getRecurlyBilling",
    "getPosBilling",
    "getOnlineStoreBilling",
    "getBookingBilling",
    "getRecurringBilling",
  ];

  const isAdminQueryPending = useAdminSelector((s) =>
    Object.values(s.adminApi.queries).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isAdminMutationPending = useAdminSelector((s) =>
    Object.values(s.adminApi.mutations).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isAccountQueryPending = useAdminSelector((s) =>
    Object.values(s.accountApi.queries).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isProductQueryPending = useAdminSelector((s) =>
    Object.values(s.adminProductsApi.queries).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isInvoiceQueryPending = useAdminSelector((s) =>
    Object.values(s.adminInvoiceApi.queries).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isInvoiceMutationPending = useAdminSelector((s) =>
    Object.values(s.adminInvoiceApi.mutations).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isAdminSecurityQueryPending = useAdminSelector((s) =>
    Object.values(s.adminSecurityApi.queries).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isAdminSecurityMutationPending = useAdminSelector((s) =>
    Object.values(s.adminSecurityApi.mutations).some(
      (q) =>
        q?.status === "pending" && !excludedQueries.includes(q?.endpointName)
    )
  );

  const isPrinterApiMutationPending = useAdminSelector((s) =>
    Object.values(s.posBasePrinterApi.mutations).some(
      (q) => q?.status === "pending"
    )
  );

  return (
    isAdminQueryPending ||
    isAdminMutationPending ||
    isAccountQueryPending ||
    isProductQueryPending ||
    isInvoiceQueryPending ||
    isInvoiceMutationPending ||
    isAdminSecurityQueryPending ||
    isAdminSecurityMutationPending ||
    isPrinterApiMutationPending
  );
};
